<template>
	<AppMore :appMore="appMore"> </AppMore>
</template>
<script>
import AppMore from '../../../../components/base/AppMore'
export default {
	props: {
		appMore: {
			type: Array,
			required: true,
		},
	},
	components: {
		AppMore,
	},
}
</script>

<style lang="scss">
.listary-landing-more {
	.block-content {
		.block-use {
			&.nutstore1 {
				li:nth-child(1) {
					background-image: url('./listary_1_icon.svg');
				}
				li:nth-child(2) {
					background-image: url('./listary_2_icon.svg');
				}
				li:nth-child(3) {
					background-image: url('./listary_3_icon.svg');
				}
				li:nth-child(4) {
					background-image: url('./listary_4_icon.svg');
				}
			}
			&.nutstore2 {
				li:nth-child(1) {
					background-image: url('./listary_5_icon.svg');
				}
				li:nth-child(2) {
					background-image: url('./listary_6_icon.svg');
				}
				li:nth-child(3) {
					background-image: url('./listary_7_icon.svg');
				}
				li:nth-child(4) {
					background-image: url('./listary_8_icon.svg');
				}
				li:nth-child(5) {
					background-image: url('./listary_9_icon.svg');
				}
			}
		}
	}
}
</style>
